import { render, staticRenderFns } from "./handicap.vue?vue&type=template&id=40dc6018&"
import script from "./handicap.vue?vue&type=script&lang=js&"
export * from "./handicap.vue?vue&type=script&lang=js&"
import style0 from "./handicap.vue?vue&type=style&index=0&id=40dc6018&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports